import { AxiosStatic, AxiosInstance } from "axios";
import { Dispatch, Action } from "redux";
import moment from "moment"; // TODO: Do we really need this for all the bloat that it
import {
  IOwnerTicketInfo,
  IError,
  ShareStatus,
  ErrorTypes,
  ShareOptions
} from "../../../interface/IShareInfo";
import { errorResponseHandler } from "../../../commons/utils/errorMessagesHandler";

export enum TicketSharingActionTypes {
  LOAD_TICKET_SHARING_DATA_PENDING = "LOAD_TICKET_SHARING_DATA_PENDING",
  LOAD_TICKET_SHARING_DATA_SUCCESS = "LOAD_TICKET_SHARING_DATA_SUCCESS",
  LOAD_TICKET_SHARING_DATA_FAILED = "LOAD_TICKET_SHARING_DATA_FAILED",
  SUBMIT_TICKET_SHARING_PENDING = "SUBMIT_TICKET_SHARING_PENDING",
  SUBMIT_TICKET_SHARING_SUCCESS = "SUBMIT_TICKET_SHARING_SUCCESS",
  SUBMIT_TICKET_SHARING_FAILED = "SUBMIT_TICKET_SHARING_FAILED"
}

const api_base = "/tickets";

export interface ILoadTicketSharingDataSuccess {
  type: TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_SUCCESS;
  payload: IOwnerTicketInfo;
}

export interface ILoadTicketSharingDataFailed {
  type: TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_FAILED;
  error: IError;
}

export interface ILoadTicketSharingDataPending {
  type: TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_PENDING;
}

export interface ISubmitSharingSuccess {
  type: TicketSharingActionTypes.SUBMIT_TICKET_SHARING_SUCCESS;
}

export interface ISubmitSharingFailed {
  type: TicketSharingActionTypes.SUBMIT_TICKET_SHARING_FAILED;
  error: IError;
}

export interface ISubmitSharingPending {
  type: TicketSharingActionTypes.SUBMIT_TICKET_SHARING_PENDING;
}

export const submitSharing = ({
  shareOption,
  optionValue
}: {
  shareOption: ShareOptions;
  optionValue: string;
}) => async (dispatch: Dispatch, getState: any, axios: AxiosStatic) => {
  const { ticketGroupId, ticketId } = getState().ticketShareData.data;

  dispatch<ISubmitSharingPending>({
    type: TicketSharingActionTypes.SUBMIT_TICKET_SHARING_PENDING
  });

  try {
    const response = await axios.post<{
      shareOption: ShareOptions;
      optionValue: string;
    }>(`${api_base}/${ticketGroupId}/share/?t=${ticketId}`, {
      type: shareOption,
      to: optionValue
    });

    dispatch<ISubmitSharingSuccess>({
      type: TicketSharingActionTypes.SUBMIT_TICKET_SHARING_SUCCESS
    });
  } catch (error) {
    const errorMessage: IError = {
      type: ErrorTypes.NETWORK_ERROR,
      message: "Sorry you can't share the ticket now."
    };

    dispatch<ISubmitSharingFailed>({
      type: TicketSharingActionTypes.SUBMIT_TICKET_SHARING_FAILED,
      error: errorResponseHandler(error, errorMessage) as IError
    });
  } finally {
    // dispatch<IHideLoading>(hideLoading());
  }
};

const handleSchema = (data: any) => {
  const shareData = {
    shareStatus: ShareStatus.ErrorStatus,
    venueInfo: {
      date: "",
      eventName: "",
      eventDescription: "",
      when: "",
      venueName: "",
      state: "",
      productId: ""
    },
    seatInfo: {
      sectionNumber: "",
      rowNumber: "",
      seatNumber: ""
    },
    ticketGroupId: "",
    ticketId: ""
  };

  if (!data || !data.data || !data.data.product || !data.data.seats) {
    return shareData;
  }

  shareData.shareStatus = data.data.current
    ? data.data.current.status
    : ShareStatus.Init;

  const {
    date,
    description,
    title,
    venue_state,
    venue_name,
    venue_timezone,
    when,
    id
  } = data.data.product;
  shareData.venueInfo = {
    date,
    eventName: title,
    eventDescription: description,
    venueName: venue_name,
    productId: id,
    when: date
      ? moment(date)
          .utcOffset(venue_timezone)
          .format("ddd D MMMM YYYY h:mma")
          .toUpperCase()
      : when,
    state: venue_state
  };
  const { section, row, name } = data.data.seats[0];
  shareData.seatInfo = {
    sectionNumber: section,
    rowNumber: row,
    seatNumber: name
  };

  shareData.ticketGroupId = data.data.ticketGroupId;
  shareData.ticketId = data.data.ticketId;

  return shareData;
};

export const loadTicketSharingData = (
  ticketGroupId: string,
  ticketId: string
) => async (dispatch: Dispatch, getState: any, axios: AxiosInstance) => {
  dispatch<ILoadTicketSharingDataPending>({
    type: TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_PENDING
  });

  try {
    const url = ticketId
      ? `${api_base}/${ticketGroupId}/share?t=${ticketId}`
      : `${api_base}/${ticketGroupId}/share`;

    const response = await axios.get<IOwnerTicketInfo>(url);
    const data = handleSchema(response.data);

    dispatch<ILoadTicketSharingDataSuccess>({
      type: TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_SUCCESS,
      payload: (data as unknown) as IOwnerTicketInfo
    });
  } catch (error) {
    dispatch<ILoadTicketSharingDataFailed>({
      type: TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_FAILED,
      error: errorResponseHandler(error) as IError
    });
  } finally {
    // dispatch<IHideLoading>(hideLoading());
  }
};

export type LoadTicketSharingDataActions =
  | ILoadTicketSharingDataSuccess
  | ILoadTicketSharingDataPending
  | ILoadTicketSharingDataFailed
  | ISubmitSharingPending
  | ISubmitSharingSuccess
  | ISubmitSharingFailed;
